module.exports = __webpack_public_path__ + "img/white04_128.7086d373.png";